import type { OrderingBasketAddonChoice } from '@/domains/pjazza/types/models/OrderingBasket.types.ts'

/**
 * Identity of a basket line. The same menu item with different options — or
 * different notes, or a different count of an option — is a separate line, so
 * adding "no onions" twice stacks while "no onions" and "extra cheese" stay apart.
 *
 * An option that follows the item adds no count, so its key reads as it always did.
 * Options are sorted so selection order cannot split an otherwise identical line.
 */
export const basketLineKey = (menuItemId: number, addons: OrderingBasketAddonChoice[], notes: string | null): string =>
  [
    menuItemId,
    addons
      .map(addon => (addon.quantity === null ? addon.id : `${addon.id}x${addon.quantity}`))
      .sort()
      .join(','),
    (notes ?? '').trim().toLowerCase()
  ].join('|')
